// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSiren24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18.6146 7.09849C17.8411 6.07521 16.827 5.23364 15.6819 4.66467L15.6816 4.66441C15.3778 4.5134 15.254 4.14483 15.405 3.84102C15.556 3.53721 15.9245 3.41333 16.2284 3.56434C17.5429 4.21778 18.7067 5.18348 19.5943 6.35777C19.7991 6.62857 19.7454 7.01377 19.4748 7.21828C19.364 7.30197 19.234 7.34241 19.105 7.34241C18.9192 7.34241 18.7354 7.2582 18.6146 7.09849ZM4.6159 7.73277C4.49765 7.73277 4.37837 7.69872 4.27292 7.62757C3.99189 7.43791 3.91766 7.05604 4.10732 6.77475C4.96424 5.50472 6.12805 4.44816 7.47306 3.71896C7.7715 3.55746 8.14416 3.66829 8.30592 3.96647C8.46743 4.2649 8.3566 4.63757 8.05842 4.79933C6.88668 5.43434 5.87235 6.35499 5.12575 7.46197C5.00699 7.63781 4.81323 7.73277 4.6159 7.73277ZM19.009 16.8824H18.8485V12.2182C18.8485 10.3889 18.1362 8.6692 16.8426 7.37563C15.549 6.08206 13.8293 5.36975 12 5.36975C10.1708 5.36975 8.45104 6.08206 7.15747 7.37563C5.8639 8.6692 5.15159 10.3889 5.15159 12.2182V16.8824H4.99111C4.39705 16.8824 3.91382 17.3656 3.91382 17.9597V19.4229C3.91382 20.017 4.39705 20.5002 4.99111 20.5002H19.009C19.603 20.5002 20.0863 20.017 20.0863 19.4229V17.9597C20.0863 17.3656 19.603 16.8824 19.009 16.8824ZM6.38015 12.2182C6.38015 10.7171 6.96474 9.30574 8.02616 8.24432C9.08758 7.1829 10.4989 6.59831 12 6.59831C13.5012 6.59831 14.9125 7.1829 15.9739 8.24432C17.0353 9.30574 17.6199 10.7171 17.6199 12.2182V16.8824H6.38015V12.2182ZM18.8577 19.2717H5.14212V18.1109H18.8577V19.2717ZM8.04487 10.0953C8.59644 9.06916 9.71878 7.84598 11.9322 7.84598C12.2714 7.84598 12.5465 8.12112 12.5465 8.46026C12.5465 8.79939 12.2714 9.07454 11.9322 9.07454C10.6558 9.07454 9.71801 9.60256 9.14468 10.6443C8.68653 11.4771 8.62638 12.3407 8.62587 12.3494C8.60719 12.676 8.33639 12.9273 8.01338 12.9273C8.00135 12.9273 7.98932 12.9271 7.97729 12.9263C7.63842 12.9069 7.37991 12.6153 7.39936 12.2767C7.40192 12.2319 7.46949 11.1656 8.04487 10.0953Z"
				/>
			</Svg>
		);
	}
);
SvgSiren24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSiren24;
